"use strict";

import angular from "angular";
import { FilesUploadGateway } from "../../../gateway/FilesUploadGateway";
import { InternalUser } from "../../../gateway/InternalUser/InternalUser";
import { User } from "../../../gateway/User/User";
import "./themes/update-user-dialog.scss";

export class UpdateUserCtrl {
    constructor(
        $scope,
        $stateParams,
        $mdDialog,
        $rootScope,
        DSNDialogService,
        $timeout,
        locals
    ) {
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.locals = locals;
        this.DSNDialogService = DSNDialogService;
        this.$rootScope = $rootScope;
        this.$mdDialog = $mdDialog;
        this.$timeout = $timeout;
        this.data = locals.data;
        this.isCreating = locals.isCreating;
        this.onOperationStart = locals.onOperationStart;
        this.onOperationComplete = locals.onOperationComplete;
        this.permissions = [
            "Super",
            "Sucesso",
            "NuHacker",
            "ChampionsLeads",
            "Heads"
        ];
        this.status = ["ATIVO", "INATIVO"];
        this.InternalUser = new InternalUser();
        this.User = new User();
        this.avatarFile = null;
        this.avatarPreview = null;
        this.errorMessage = "";
        this.successMessage = "";
        this.pwdShow = false;
        this.pwdConfirmShow = false;
    }

    $onInit() {
        if (this.data && this.data.avatar) {
            this.avatarPreview = this.data.avatar;
        }
        if (!this.data) {
            this.data = {
                name: "",
                email: "",
                permission: "",
                status: "",
                password: "",
                confirmPassword: ""
            };
        }
    }

    onDropAvatar(files) {
        if (files && files.length > 0) {
            this.avatarFile = files[0];
            this.createAvatarPreview();
        }
    }

    createAvatarPreview() {
        if (this.avatarFile) {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.avatarPreview = e.target.result;
                this.$scope.$applyAsync();
            };
            reader.readAsDataURL(this.avatarFile);
        }
    }

    onRemoveAvatar() {
        this.avatarFile = null;
        this.avatarPreview = null;
    }

    /**
     * @public
     * @param {String} elementId - id of element
     * show the password
     */
    onShowPassword = (elementId) => {
        if (!elementId) return;
        const element = angular.element(document.getElementById(elementId))[0];
        element.type === "password"
            ? (element.type = "text")
            : (element.type = "password");
    };

    async onSubmit(form) {
        this.loading = true;
        if (this.onOperationStart) {
            this.$timeout(() => {
                this.onOperationStart();
            }, 0);
        }
        this.$mdDialog.hide();
        let avatarUrl = null;
        if (this.avatarFile) {
            avatarUrl = await this._uploadFileToAWS(this.avatarFile);
        } else if (this.data.avatar) {
            avatarUrl = this.data.avatar;
        }
        const userData = {
            _id: this.data._id,
            name: this.data.name,
            email: this.data.email,
            username: this.data.email,
            nickname: this.data.name,
            role: this.data.permission,
            status: this.data.status,
            password: this.data.password,
            companyIds: this.data.companyIds || [],
            picture: avatarUrl,
            whatsapp: this.data.whatsapp || ""
        };
        await this.InternalUser.saveMany([userData]);
        this.loading = false;
        if (this.onOperationComplete) {
            this.$timeout(() => {
                this.onOperationComplete();
            }, 0);
        }
    }

    async _uploadFileToAWS(file) {
        try {
            const buffer = await this._convertFileToBase64(file);
            const url = await this._uploadDNS(buffer);
            return url;
        } catch (error) {
            throw error;
        }
    }

    _convertFileToBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsDataURL(file);
        });
    }

    async _uploadDNS(buffer) {
        if (!buffer) return;
        const filesUploadGateway = new FilesUploadGateway();
        const response = await filesUploadGateway.image({
            accountingId: this.locals.accountingId,
            bucketName: "nucont-logos",
            base64: buffer
        });
        return response?.[0];
    }
}

angular.module("nucont.shared").controller("UpdateUserCtrl", [
    "$scope",
    "$stateParams",
    "$mdDialog",
    "$rootScope",
    "DSNDialogService",
    "$timeout",
    "locals",
    "ContractService",
    "AccountingFactory",
    UpdateUserCtrl
]);
